// generated from 490 samples

import { z } from "zod";

export const enteredGeoFenceTriggerGetSchema = z.object({
  event_type: z.literal("TrackedUserBehavior::EnteredGeoFence"),
  // null: 142 (28.98%)
  center_coordinates: z
    .tuple([
      // avg: 10.92, min: -122.43743, max: 151.20999999999998
      z.number(),
      // avg: 28.65, min: -38.723362, max: 52.517037
      z.number(),
    ])
    .nullable()
    .optional(),
  comparison_key: z.enum([
    "13", // 348 (71.02%)
    "14", // 141 (28.78%)
  ]),
  // null: 349 (71.22%)
  polygon_bounding_coordinates: z
    .array(
      z.tuple([
        // avg: 10.49, min: -132.89062, max: 148.31783000000001
        z.number(),
        // avg: 26.25, min: -36.500529337632194, max: 61.270232790000634
        z.number(),
      ])
    )
    .nullable()
    .optional(),
  // null: 142 (28.98%)
  // avg: 19.26, min: 0.002485484, max: 1876.9405829239997
  radius_in_miles: z.number().nonnegative().nullable().optional(),
});
